import React from 'react';
import { Space, Breadcrumb } from 'antd';
import { CardLayout, B2CTable } from 'components/molecules';
import SearchBox from './SearchBox'
import { useB2c, useB2cClose } from 'hooks';


export interface  LectureProps {}

const  Lecture = ({}:  LectureProps): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
 
  const { ingList, searchResult: ingSearchResult, refetch } = useB2c(0);  
  const { refetch: refecthClose, closeList, searchResult } = useB2cClose();  
 

  /* ======================================================
   * variables
   * ====================================================== */

  
  /* ======================================================
   * events
   * ====================================================== */    
  
  /* ======================================================
   * hooks
   * ====================================================== */
 

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2C</Breadcrumb.Item>
        <Breadcrumb.Item>공개과정</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
       <Space direction="vertical" style={{ width: '100%' }}>
          <SearchBox />
          <B2CTable
            title='모집중 과정'
            projectList={ingList}
            searchResult={ingSearchResult}
            hiddenColumns={['sales_profit', 'time_price']}
            refetch={refetch}
            useExcelDownload={true}
            register={true}
          />
          <div style={{height:"20px"}}></div>
          <B2CTable
            title='종료된 과정'
            projectList={closeList}
            searchResult={searchResult}
            hiddenColumns={['expect_price']}
            refetch={refecthClose}
            register={false}
          />   
        </Space>                  
    </CardLayout>
  )
};

export default  Lecture;    